module.exports = __webpack_public_path__ + "static/media/crop-demo2.b729cfc1.mp4";